import {
    AccountBalanceWalletOutlined,
    AccountBalanceWalletRounded,
    CampaignOutlined,
    CampaignRounded,
    DashboardOutlined,
    DashboardRounded,
    EmailRounded,
    ExtensionOutlined,
    ExtensionRounded,
    FolderOutlined,
    FolderRounded,
    Groups2Outlined,
    Groups2Rounded,
    GroupsRounded,
    HourglassTopOutlined,
    HourglassTopRounded,
    InsertDriveFileOutlined,
    InsertDriveFileRounded,
    InterestsOutlined,
    InterestsRounded,
    LabelOutlined,
    LabelRounded,
    MergeTypeOutlined,
    MergeTypeRounded,
    PendingActionsOutlined,
    PendingActionsRounded,
    PersonOutlined,
    PersonRounded,
    RunningWithErrorsOutlined,
    RunningWithErrorsRounded,
    ScheduleSendOutlined,
    ScheduleSendRounded,
    SendOutlined,
    SendRounded,
    TaskAltOutlined,
    TaskAltRounded,
    ViewListOutlined,
    ViewListRounded,
    VolunteerActivismOutlined,
    VolunteerActivismRounded,
    WorkspacesOutlined,
    WorkspacesRounded,
} from '@mui/icons-material';

export const routes = [
    {
        name: 'Contacts',
        icon: GroupsRounded,
        path: '/contacts',
        routes: [
            {
                name: 'Contacts',
                path: '/',
                Icon: PersonOutlined,
                SelectedIcon: PersonRounded,
            },
            {
                name: 'Groups',
                path: '/groups',
                Icon: Groups2Outlined,
                SelectedIcon: Groups2Rounded,
            },
            // {
            //     name: 'Tasks',
            //     path: '/tasks',
            //     Icon: TaskAltOutlined,
            //     SelectedIcon: TaskAltRounded,
            // },
            // {
            //     name: 'Task Types',
            //     path: '/task-types',
            //     Icon: LabelOutlined,
            //     SelectedIcon: LabelRounded,
            // },
            // {
            //     name: 'Fix and Merge',
            //     path: '/fix-and-merge',
            //     Icon: MergeTypeOutlined,
            //     SelectedIcon: MergeTypeRounded,
            // },
        ],
    },
    {
        name: 'Emails',
        icon: EmailRounded,
        path: '/emails',
        routes: [
            {
                name: 'Sent',
                path: '/',
                Icon: SendOutlined,
                SelectedIcon: SendRounded,
            },
            {
                name: 'Drafts',
                path: '/drafts',
                Icon: InsertDriveFileOutlined,
                SelectedIcon: InsertDriveFileRounded,
            },
            // {
            //     name: 'Single Emails',
            //     path: '/single-emails',
            //     Icon: InsertDriveFileOutlined,
            //     SelectedIcon: InsertDriveFileRounded,
            // },
            {
                name: 'Scheduled',
                path: '/scheduled',
                Icon: ScheduleSendOutlined,
                SelectedIcon: ScheduleSendRounded,
            },
            // {
            //     name: 'Mailing Lists',
            //     path: '/mailing-lists',
            //     Icon: ViewListOutlined,
            //     SelectedIcon: ViewListRounded,
            // },
            // {
            //     name: 'Designs',
            //     path: '/designs',
            //     Icon: InterestsOutlined,
            //     SelectedIcon: InterestsRounded,
            // },
            {
                name: 'Templates',
                path: '/templates',
                Icon: DashboardOutlined,
                SelectedIcon: DashboardRounded,
            },
        ],
    },
    // {
    //     name: 'Donations',
    //     icon: VolunteerActivismRounded,
    //     path: '/donations',
    //     routes: [
    //         {
    //             name: 'Donations',
    //             path: '/',
    //             Icon: VolunteerActivismOutlined,
    //             SelectedIcon: VolunteerActivismRounded,
    //         },
    //         {
    //             name: 'Pledges',
    //             path: '/pledges',
    //             Icon: PendingActionsOutlined,
    //             SelectedIcon: PendingActionsRounded,
    //         },
    //         {
    //             name: 'Categories',
    //             path: '/categories',
    //             Icon: LabelOutlined,
    //             SelectedIcon: LabelRounded,
    //         },
    //         {
    //             name: 'Groups',
    //             path: '/groups',
    //             Icon: WorkspacesOutlined,
    //             SelectedIcon: WorkspacesRounded,
    //         },
    //         {
    //             name: 'Fix and Merge',
    //             path: '/fix-and-merge',
    //             Icon: MergeTypeOutlined,
    //             SelectedIcon: MergeTypeRounded,
    //         },
    //     ],
    // },
    // {
    //     name: 'Expenses',
    //     icon: AccountBalanceWalletRounded,
    //     path: '/expenses',
    //     routes: [
    //         {
    //             name: 'Expenses',
    //             path: '/',
    //             Icon: AccountBalanceWalletOutlined,
    //             SelectedIcon: AccountBalanceWalletRounded,
    //         },
    //         {
    //             name: 'Categories',
    //             path: '/categories',
    //             Icon: LabelOutlined,
    //             SelectedIcon: LabelRounded,
    //         },
    //         {
    //             name: 'Unpaid Expenses',
    //             path: '/unpaid',
    //             Icon: RunningWithErrorsOutlined,
    //             SelectedIcon: RunningWithErrorsRounded,
    //         },
    //         {
    //             name: 'Upcoming Expenses',
    //             path: '/upcoming',
    //             Icon: HourglassTopOutlined,
    //             SelectedIcon: HourglassTopRounded,
    //         },
    //     ],
    // },
    // {
    //     name: 'Files',
    //     icon: FolderRounded,
    //     path: '/files',
    //     routes: [
    //         {
    //             name: 'Files',
    //             path: '/',
    //             Icon: FolderOutlined,
    //             SelectedIcon: FolderRounded,
    //         },
    //     ],
    // },
    // {
    //     name: 'Campaigns',
    //     icon: CampaignRounded,
    //     path: '/campaigns',
    //     routes: [
    //         {
    //             name: 'Campaigns',
    //             path: '/',
    //             Icon: CampaignOutlined,
    //             SelectedIcon: CampaignRounded,
    //         },
    //         {
    //             name: 'Sub Campaigns',
    //             path: '/sub-campaigns',
    //             Icon: CampaignOutlined,
    //             SelectedIcon: CampaignRounded,
    //         },
    //         {
    //             name: 'Dashboards',
    //             path: '/dashboards',
    //             Icon: CampaignOutlined,
    //             SelectedIcon: CampaignRounded,
    //         },
    //     ],
    // },
    {
        name: 'Addons',
        icon: ExtensionRounded,
        path: '/addons',
        routes: [
            {
                name: 'Addons',
                path: '/',
                Icon: ExtensionOutlined,
                SelectedIcon: ExtensionRounded,
            },
        ],
    },
];

export const getSecondaryRoutes = primaryRoute => {
    const route = routes.find(({ path }) => path === primaryRoute);
    return route?.routes || [];
};
